import axios from 'axios';
import store from "../appRedux/store/index";
import { userSignOut } from '../appRedux/actions';

axios.defaults.withCredentials = true;

let mainInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

mainInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401 && !error.config?.suppressAuthRedirect) {
      store.dispatch(userSignOut());
    }
    return Promise.reject(error);
  },
);

export default mainInstance;
